package games.polyclub.frontend.store.shared

import games.polyclub.service.profile.api.PlayerProfile
import games.polyclub.tool.strings.Currency
import kotlinx.serialization.Serializable

@Serializable
data class LoginResponse(
    val roles: List<String>,
    val accessToken: String,
    val profile: PlayerProfile,
    val currency: Currency?,
)
